<template>

  <cmpnavigation></cmpnavigation>
  <router-view></router-view>
  
</template>

<script>

import cmpnavigation from "./components/cmpnavigation.vue"

//import { onBeforeUpdate,onMounted,onUpdated} from 'vue'


export default {
  name: "App",

  components: {
    cmpnavigation
    
  },

  setup(){

    /*
    onMounted(() =>{
        console.log("onMounted app");

    });


    onBeforeUpdate(() =>{
        console.log("onBeforeUpdate app");

    });

    onUpdated(() =>{
        console.log("onBeforeUpdate app");

    });
    */

  },

  created(){
      //console.log("app created");
      
  },

  data(){

    return {
        
    }
    
    
    
  },
  
  methods:{

  
  }

}
</script>

<style>

html{

  background-color: rgba(0, 0, 0, 0.7);

     
  background-repeat: repeat;
  /*background-image: url("~@/assets/images/bg.jpg");*/


  scroll-behavior: smooth;
  

}



#newlabapp {
  
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 60px 0 rgba(0, 0, 0, 0.2);

    font-family: "Montserrat", serif;
    
    background-color: white;

    /*max-width: 1200px;*/
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: auto;
    margin-right: auto;
    overflow: auto;

    position: relative;
    padding: 0px;


    min-height: 100vh;

}

input{
  font-family: "Montserrat", serif;
}
  


  @media screen and (min-width: 700px)    {
      /*  schermo desktop */
   

      
  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
    
    body{
      width: 100vw;
      margin: 0;
    }






  }






</style>

